import React from "react";

const BasicLayout = ({ children }) => {
  return (
    <div>
      {/* <header>Header for Basic Pages</header> */}
      <main>{children}</main>
      {/* <footer>Footer</footer> */}
    </div>
  );
};

export default BasicLayout;
